import { Entity, field, rootCollection } from 'firebase-firestorm/lib'

@rootCollection({ name: 'glCodeProductCategory' })
export class GLCodeProductCategory extends Entity {
  @field({ name: 'id' })
  id!: string

  @field({ name: 'productCategoryId' })
  productCategoryId!: string

  @field({ name: 'restaurantId' })
  restaurantId!: string

  @field({ name: 'glCode' })
  glCode!: string
}
